
$(document).ready(function () {
    if($('.product-page').length) {
        google.charts.load('current', {'packages':['corechart']});
        
        google.charts.setOnLoadCallback(view_traffic);

        google.charts.setOnLoadCallback(visitors_traffic);

        //First chart
        function view_traffic() {
            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Date');
            data.addColumn('number', '');
            data.addColumn({type: 'string', role: 'tooltip', p: {html:true}});
            var rows = [];
            var arr = []
            var arr = $('#view_traffic').length ? JSON.parse($('#view_traffic').attr('data-traffic')) : [];
            var format = $('#view_traffic').length ? $('#view_traffic').attr('data-format') : "#### млн";
            for (var i = 0; i < arr.length; i++) {
                rows.push([
                    arr[i].date_str,
                    Number(arr[i].views_str),
                    createCustomHTMLContent(arr[i].date_at, arr[i].url, Number(arr[i].views))
                ]);
            }
            data.addRows(rows);

            var options = {
                width:'100%',
                height:'100%',
                colors:['#8f44ad'],
                pointSize: 5,
                legend: 'none',
                backgroundColor: 'transparent',
                areaOpacity: 0.05,
                tooltip: { 
                    isHtml: true 
                },
                hAxis: {
                    showTextEvery: 1,
                    textStyle: {
                        fontSize: 10,
                        color: '#858290'
                    },
                    baselineColor: 'transparent',
                    gridlines: {
                        color: 'transparent',
                        count: 2
                    }
                },
                vAxis: {
                    minValue: 0,
                    format: format,//"#### млн",
                    baselineColor: '#F1F1F2',
                    gridlines: {
                        color: '#F1F1F2',
                        count: 2
                    },
                    textStyle: {
                        fontSize: 10,
                        color: '#858290'
                    }
                },
                chartArea: {
                    left: 60,
                    top: 10,
                    right: 20,
                    bottom: 30,
                    width: '100%',
                    height: '100%'
                }
            };

            function createCustomHTMLContent(date, url, views) {
                return '<div class="chart_tooltip">' +
                    '<span>' + date + '</span>' +
                    '<span>' + url + '</span>' +
                    '<span class="views_number"><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M6 2.07947C3.35322 2.07947 1.07204 3.63973 0.0241377 5.8913C-0.00804592 5.95953 -0.00804592 6.03935 0.0241377 6.10886C1.07204 8.36042 3.35323 9.9207 6 9.9207C8.64677 9.9207 10.928 8.36043 11.9759 6.10886C12.008 6.04063 12.008 5.96082 11.9759 5.8913C10.928 3.63973 8.64678 2.07947 6 2.07947ZM6 8.70545C4.50539 8.70545 3.29528 7.49405 3.29528 6.00073C3.29528 4.50612 4.50668 3.29601 6 3.29601C7.49461 3.29601 8.70471 4.5074 8.70471 6.00073C8.70471 7.49405 7.49332 8.70545 6 8.70545Z" fill="#172EFE"></path><path d="M5.99979 7.73094C6.95606 7.73094 7.73127 6.95572 7.73127 5.99944C7.73127 5.04316 6.95606 4.26794 5.99979 4.26794C5.04352 4.26794 4.26831 5.04316 4.26831 5.99944C4.26831 6.95572 5.04352 7.73094 5.99979 7.73094Z" fill="#172EFE"></path></svg>' + views + '</span>' +
                    '</div>';
            }

            var chart_area = document.getElementById('view_traffic');
            var chart = new google.visualization.AreaChart(document.getElementById('view_traffic'));
            google.visualization.events.addOneTimeListener(chart, 'ready', function () {
                addChartGradient(chart);
                var labels = chart_area.getElementsByTagName('text');
                Array.prototype.forEach.call(labels, function(label) {
                    if(!label.nextSibling) {
                        if (label.getAttribute('text-anchor') === 'middle') {
                            label.setAttribute('y', parseFloat(label.getAttribute('y')) + 10);
                        }
                    }
                });
            });
            chart.draw(data, options);
        }

        // For first chart gradient
        function addChartGradient(chart) {
            var chartDiv = chart.getContainer();
            var svg = chartDiv.getElementsByTagName('svg')[0];
            var properties = {
                id: "chartGradient",
                x1: "0%",
                y1: "0%",
                x2: "0%",
                y2: "100%",
                stops: [
                    { offset: '0%', 'stop-color': '#7222ff' },
                    { offset: '100%', 'stop-color': '#d443a2' }
                ]
            };
            
        
            createGradient(svg, properties);
            var chartPath = svg.getElementsByTagName('path')[1];  //0 path corresponds to legend path
            if(chartPath) {
                chartPath.setAttribute('stroke', 'url(#chartGradient)');
            }
        }

        function createGradient(svg, properties) {
            var svgNS = svg.namespaceURI;
            var grad = document.createElementNS(svgNS, 'linearGradient');
            grad.setAttribute('id', properties.id);
            ["x1","y1","x2","y2"].forEach(function(name) {
                if (properties.hasOwnProperty(name)) {
                    grad.setAttribute(name, properties[name]);
                }
            });
            for (var i = 0; i < properties.stops.length; i++) {
                var attrs = properties.stops[i];
                var stop = document.createElementNS(svgNS, 'stop');
                for (var attr in attrs) {
                    if (attrs.hasOwnProperty(attr)) stop.setAttribute(attr, attrs[attr]);
                }
                grad.appendChild(stop);
            }
        
            var defs = svg.querySelector('defs') ||
                svg.insertBefore(document.createElementNS(svgNS, 'defs'), svg.firstChild);
            return defs.appendChild(grad);
        }

        //Second chart
        function visitors_traffic() {
            var data = new google.visualization.DataTable();
            data.addColumn('string', 'Names');
            data.addColumn('number', 'Value');
            data.addColumn({type: 'string', role: 'annotation', p: {html:true}}); 
            data.addColumn({ role: 'style' });          
            data.addRows([
                ['Direct',  Number($('#visitors_traffic').attr('data-direct')), $('#visitors_traffic').attr('data-direct')+'%', 'color: #2A9CEE; stroke-width: 0;'],
                ['Referrals',  Number($('#visitors_traffic').attr('data-referrals')), $('#visitors_traffic').attr('data-referrals')+'%', 'color: #8610E2; stroke-width: 0;'],
                ['Search',  Number($('#visitors_traffic').attr('data-search')), $('#visitors_traffic').attr('data-search')+'%', 'color: #149B93; stroke-width: 0;'],
                ['Social',  Number($('#visitors_traffic').attr('data-social')), $('#visitors_traffic').attr('data-social')+'%', 'color: #DF9300; stroke-width: 0;'],
                ['Mail',  Number($('#visitors_traffic').attr('data-mail')), $('#visitors_traffic').attr('data-mail')+'%', 'color: #FF6107; stroke-width: 0;'],
                ['Advertising',  Number($('#visitors_traffic').attr('data-advertising')), $('#visitors_traffic').attr('data-advertising')+'%', 'color: #FF5CDB; stroke-width: 0;'],
            ]);

            var options = {
                width:'100%',
                height:'100%',
                legend: 'none',
                backgroundColor: 'transparent',
                areaOpacity: 0.05,
                tooltip: { 
                    isHtml: true ,
                    trigger: 'none'
                },
                annotations: {
                    alwaysOutside: true,
                    textStyle: {
                        fontSize: 12,
                        bold: 500,
                        color: '#261d56',
                    },
                    stem: {
                        color: 'transparent',
                        length: 8
                    }
                },
                hAxis: {
                    textStyle: {
                        fontSize: 12,
                        color: '#858290',
                        marginTop: '10',
                    },
                },
                vAxis: {
                    minValue: 0,
                    baselineColor: '#F1F1F2',
                    gridlines: {
                        color: '#F1F1F2',
                        count: 3,
                        minSpacing: 60
                    },
                    textStyle: {
                        fontSize: 12,
                        color: '#858290'
                    }
                },
                chartArea: {
                    left: 10,
                    top: 0,
                    right: 20,
                    bottom: 20,
                    width: '100%',
                    height: '100%'
                }
            };

            var chart_area = document.getElementById('visitors_traffic');
            var chart = new google.visualization.ColumnChart(chart_area);

            // added gradient to column
            google.visualization.events.addListener(chart, 'ready', function(){

                // create observer
                var observer = new MutationObserver(function () {
                var svg = chart_area.getElementsByTagName('svg')[0];
                svg.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
            
                // add gradient
                Array.prototype.forEach.call(chart_area.getElementsByTagName('rect'), function(rect) {
                    if (rect.getAttribute('fill') === '#2a9cee') {
                    rect.setAttribute('fill', 'url(#my-gradient1) #2A9CEE');
                    }
                    if (rect.getAttribute('fill') === '#8610e2') {
                    rect.setAttribute('fill', 'url(#my-gradient2) #8610E2');
                    }
                    if (rect.getAttribute('fill') === '#149b93') {
                    rect.setAttribute('fill', 'url(#my-gradient3) #149B93');
                    }
                    if (rect.getAttribute('fill') === '#df9300') {
                    rect.setAttribute('fill', 'url(#my-gradient4) #DF9300');
                    }
                    if (rect.getAttribute('fill') === '#ff6107') {
                    rect.setAttribute('fill', 'url(#my-gradient5) #FF6107');
                    }
                    if (rect.getAttribute('fill') === '#ff5cdb') {
                    rect.setAttribute('fill', 'url(#my-gradient6) #FF5CDB');
                    }
                });
                });
                observer.observe(chart_area, {
                childList: true,
                subtree: true
                });
            
            });

            chart.draw(data, options);
        }

        $(window).resize(function(){
            view_traffic();
            visitors_traffic();
        }); 

        setTimeout(function() {
            console.log($('.chart-block').find('[text-anchor="end"]'))
            $('.chart-block').find('[text-anchor="end"]').each(function() {
                if($(this).text() == '0 млн') {
                    $(this).text('0');
                }
            });
        }, 300);
    }
});